import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import {
  PanAppState,
  PlatformService,
  UsfTokenService,
} from '@panamax/app-state';
import { UserKinds } from '@usf/user-types/user';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { AuthConnectService } from '@panamax/app-state';
import { ProfileAnalyticsService } from '../../analytics/profile-analytics.service';
import { SimpleActionModalComponent } from 'src/app/shared/components/simple-action-modal/simple-action-modal.component';
import { FEATURES } from 'src/app/shared/constants/splitio-features';
import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { ProfileService } from '../../services/profile.service';

@Component({
  selector: 'app-profile-security-card',
  templateUrl: './profile-security-card.component.html',
  styleUrls: ['./profile-security-card.component.scss'],
})
export class ProfileSecurityCardComponent implements OnInit, OnDestroy {
  @Output() showToast = new EventEmitter();
  @Input() isMobile: boolean;
  @Input() accountInfo: {
    loginEmail?: string;
    loginPhoneNumber?: string;
    userName?: string;
    userSince?: string;
    lastLoginDtm?: string;
  };
  @Input() userKind: string;
  featureFlag$: Subscription;
  handleLogoutSub$: Subscription;
  logoutAllSessions: boolean;

  constructor(
    readonly panAppState: PanAppState,
    readonly platformService: PlatformService,
    private translateService: TranslateService,
    private modalController: ModalController,
    private modalService: ModalService,
    private profileService: ProfileService,
    private profileAnalyticsService: ProfileAnalyticsService,
    private authConnectService: AuthConnectService,
    private tokenService: UsfTokenService,
  ) {}

  ngOnInit() {
    this.featureFlag$ = this.panAppState
      .feature$([FEATURES.split_global_logout_all_sessions.name])
      ?.subscribe(on => {
        this.logoutAllSessions = on;
      });
  }

  disableChange() {
    return this.userKind !== UserKinds.External;
  }

  changeLoginInformation() {
    this.profileService.changeLoginInformation(this.accountInfo.userName);
  }

  async logOutAllSessions() {
    this.modalService.setModalOptions(
      this.platformService.isTouch.value,
      SimpleActionModalComponent,
      {
        title: this.translateService.instant(
          'i18n.profilePage.security.logOutAllSessions',
        ),
        content: this.translateService.instant(
          'i18n.profilePage.security.logOutAllSessionsText',
        ),
        leftButtonText: 'i18n.common.cancel',
        rightButtonText: 'i18n.common.continue',
      },
      'simple-action-modal',
    );
    const modal = await this.modalController.create(
      this.modalService.modalOptions,
    );
    modal.onDidDismiss().then(async (response: any) => {
      let result = response?.data?.dispatchAction;
      if (result) {
        this.profileAnalyticsService.traceLogoutSession(
          this.profileService.getUserId(),
        );
        this.panAppState.user$.pipe(take(1)).subscribe(user => {
          if (user?.userId) {
            const userKind =
              user.userKind === UserKinds.External
                ? user.userKind
                : UserKinds.Internal;
            this.tokenService
              .logoutAllSessions(user.userId, userKind)
              .then(response => {
                if (response.status === 'success') {
                  this.authConnectService.logout().then(_ => {
                    this.profileAnalyticsService.traceLogoutSessionSuccess(
                      this.profileService.getUserId(),
                    );
                  });
                } else {
                  this.showToast.emit({
                    toastMessage:
                      'i18n.profilePage.toast.logOutAllSessionsError',
                    type: 'error',
                  });
                }
              });
          }
        });
      }
    });
    return await modal.present();
  }

  ngOnDestroy() {
    if (this.featureFlag$) {
      this.featureFlag$.unsubscribe();
    }
    if (this.handleLogoutSub$) {
      this.handleLogoutSub$.unsubscribe();
    }
  }
}
